import React from "react";

export function Resolution() {
    return (
        <>
        <center>
        <div class="right2">
            <br/>
            <br/>
            <br/>
            <br/>
            <h1 className="text-5xl md:text-5xl font-bold mb-6">Monroe Township Fire District #1 Budget Resolutions</h1><hr/>
            <ul>
                <br/>
                
            <a href="https://diuy0t6boke2n.cloudfront.net/20260218114724014.pdf"><button>2026 Resolutions</button></a><br/><br/>

            <a href="https://diuy0t6boke2n.cloudfront.net/Finances/Budgets/MTFD1-_Budget_Resolution.pdf"><button>2013 Fiscal Year Resolutions</button></a><br/><br/>
            </ul>
        </div>
        </center>
        </>
    )
}